/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceRunbookOptions = {
  value: FinVoiceRunbook;
  text: string;
};

export type FinVoiceRunbook =
  | 'none'
  | 'card_reader_troubleshooting'
  | 'flex_terminal_card_reader'
  | 'damaged_card_reader'
  | 'nfc_only_flex_terminal'
  | 'swipe_only_flex_terminal'
  | 'elo_terminal_card_reader_issue'
  | 'insert_only_elo_terminal'
  | 'swipe_only_elo_terminal'
  | 'network_offline'
  | 'nfc_only_elo_terminal'
  | 'dual_card_reader_setup_not_working_flex_terminal'
  | 'dual_card_reader_setup_not_working_elo_terminal'
  | 'all_functions_not_working_elo_terminal'
  | 'all_functions_not_working_flex_terminal'
  | 'elo_dynamag_msr_not_working';

export const FIN_VOICE_RUNBOOK_OPTIONS: FinVoiceRunbookOptions[] = [
  { value: 'none', text: 'ai-agent.voice-playground.settings.runbook-none' },
  {
    value: 'card_reader_troubleshooting',
    text: 'ai-agent.voice-playground.settings.runbook-card-reader-troubleshooting',
  },
  {
    value: 'flex_terminal_card_reader',
    text: 'ai-agent.voice-playground.settings.runbook-flex-terminal-card-reader',
  },
  {
    value: 'damaged_card_reader',
    text: 'ai-agent.voice-playground.settings.runbook-damaged-card-reader',
  },
  {
    value: 'nfc_only_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-nfc-only-flex-terminal',
  },
  {
    value: 'swipe_only_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-swipe-only-flex-terminal',
  },
  {
    value: 'elo_terminal_card_reader_issue',
    text: 'ai-agent.voice-playground.settings.runbook-elo-terminal-card-reader-issue',
  },
  {
    value: 'insert_only_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-insert-only-elo-terminal',
  },
  {
    value: 'swipe_only_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-swipe-only-elo-terminal',
  },
  {
    value: 'network_offline',
    text: 'ai-agent.voice-playground.settings.runbook-network-offline',
  },
  {
    value: 'nfc_only_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-nfc-only-elo-terminal',
  },
  {
    value: 'dual_card_reader_setup_not_working_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-flex-terminal',
  },
  {
    value: 'dual_card_reader_setup_not_working_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-dual-card-reader-setup-not-working-elo-terminal',
  },
  {
    value: 'all_functions_not_working_elo_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-elo-terminal',
  },
  {
    value: 'all_functions_not_working_flex_terminal',
    text: 'ai-agent.voice-playground.settings.runbook-all-functions-not-working-flex-terminal',
  },
  {
    value: 'elo_dynamag_msr_not_working',
    text: 'ai-agent.voice-playground.settings.runbook-elo-dynamag-msr-not-working',
  },
];
